import Button from '@veeva/corgix/button';
import { reload } from '../services/browserUtils';
import Dialog from './Dialog';
import useMessageService from '../services/i18n/useMessageService';

const InvalidSessionDialog = () => {
    const [
        [
            myAccountSessionInvalidDialogTitle = 'Invalid Session',
            myAccountSessionInvalidDialogContent = 'Your session is invalid. The application will refresh to fix this issue.',
            continueText = 'Continue',
        ],
        messagesLoading,
    ] = useMessageService([
        'my_account.session_invalid_dialog_title',
        'my_account.session_invalid_dialog_content',
        'general.continue',
    ]);

    const handleContinue = () => {
        reload();
    };

    const actions = [
        <Button key="continue" variant="primary" onClick={handleContinue}>
            {continueText}
        </Button>,
    ];

    if (messagesLoading) {
        return null;
    }

    return (
        <Dialog title={myAccountSessionInvalidDialogTitle} actions={actions} open>
            {myAccountSessionInvalidDialogContent}
        </Dialog>
    );
};

export default InvalidSessionDialog;
